import { setTheme } from "theme/default/setTheme";

export const setFontSize_12px = setTheme(({ theme }) => `font-size: ${theme.fontSize.font_size_12px}`);
